import { UserCheck, Loader2 } from "lucide-react";
import useFollow from "../../hooks/useFollow";

const FollowButton = ({ profileId, initialFollowing = false }) => {
  const { isFollowing, loading, error, toggleFollow } = useFollow(profileId, initialFollowing);

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        onClick={toggleFollow}
        disabled={loading}
        className={`flex items-center gap-2 px-5 py-2 rounded-full
          text-sm font-bold transition-all duration-200
          hover:scale-105 active:scale-95
          ${loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
        style={isFollowing ? {
          background: 'rgba(255,255,255,0.08)',
          color: 'rgba(255,255,255,0.7)',
          border: '1px solid rgba(255,255,255,0.15)',
        } : {
          background: '#2563EB',
          color: '#fff',
          boxShadow: '0 4px 20px rgba(37,99,235,0.5)',
        }}
      >
        {loading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : isFollowing ? (
          <><UserCheck className="w-4 h-4" />Following</>
        ) : (
          "Follow"
        )}
      </button>

      {error && <span className="text-xs text-red-400">{error}</span>}
    </div>
  );
};

export default FollowButton;
